<template>
    <div>
        <form method="GET" action="search" @submit="formSubmit" class="w-full pb-4 px-4 md:px-7 relative">
            <input ref="input" :value="searchInput" name="q" @input="$emit('update:searchInput', $event.target.value)"
                placeholder="국내 모든 공공데이터를 한 번에 찾아보세요." 
                class="w-full px-4 md:px-8 py-4 text-xs md:text-base bg-white focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-2 border">
            <button ref="button" type="submit" class="absolute py-4 right-10 md:right-14">
                <svg xmlns="http://www.w3.org/2000/svg" ref="button" type="submit" class="w-5 h-5 md:w-6 md:h-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: "SearchRect",
    props: {
        searchInput: {
            type: String,
            default: ''
        }
    },
    methods: {
    formSubmit(e) {
        if (guardEvent(e)) {
        const target = this.searchInput || ''
        const { location } = this.$router.resolve('/' + target)
        this.$router.push(location)
        e.preventDefault()
        }
    }
}
}

function guardEvent (e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return false
    }
    // don't redirect when preventDefault called
    if (e.defaultPrevented) {
    return false
    }
     // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) {
    return false
    }
    return true
}
</script>
